import queryString from 'query-string';
import { isWebviewRenderTypeValue } from 'Utils/webviewMode';

export const getChannel = (location, renderType) => {
  let channel = 'WEB';
  const queryParams = queryString.parse(location?.search);

  if (isWebviewRenderTypeValue(renderType)) {
    if (queryParams.channel?.toUpperCase() === 'IOS') {
      channel = 'IOS';
    } else if (queryParams.channel?.toUpperCase() === 'ANDROID') {
      channel = 'ANDROID';
    }
  } else {
    if (window.innerWidth < 769) {
      channel = 'MOBILE_WEB';
    }
  }
  
  return channel;
};
